import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditPageEditor from "../components/EditPageEditor";

const EditPageEditorPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit' />

                <EditPageEditor />

            </MasterLayout>
        </>
    );
};

export default EditPageEditorPage;
